import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ApkContext, IApkContext } from '../../apkState/apkContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Apk.module.scss';

const Apk: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, apk, currentPage, countOfItems } = useContext<IApkContext>(ApkContext);

	return (
		<>
			{apk.count ? (
				<div className={style.container} data-test="Apk">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={apk.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Apk;
